import {
    SAGA_ERROR,
} from '../../../helpers/constants';

import {
    INTERNAL_CHAT_CONTACTS,
    ACTIVE_INTERNAL_CHAT,
    UPDATE_INTERNAL_CHAT_MESSAGING_INFO,
    IS_LOADING,
    UPDATE_INTERNAL_CHAT_CONTACT_STATUS,
    INTERNAL_CHAT_GROUPS,
    UPSERT_INTERNAL_CHAT_GROUP,
    APPLY_INTERNAL_CHAT_GROUP_UPDATE,
    PATCH_INTERNAL_CHAT_GROUP,
    ADD_INTERNAL_CHAT_GROUP_MESSAGES,
    RECEIVE_INTERNAL_CHAT_GROUP_MESSAGE,
    REMOVE_INTERNAL_CHAT_GROUP
} from '../../../helpers/internalChatConstants'

import {
    addGroupMessages,
    applyGroupUpdate,
    mergeListedGroups,
    patchGroup,
    receiveGroupMessage,
    removeGroup,
    upsertGroup
} from '../../../utils/internalChatGroups';

const initialState = {
    activeChat: {
        user: null,
        position: {
          x: 0,
          y: 0
        }
    },
    contacts: [],
    groups: [],
    userStatus: {},
    messaging: {},
    isLoading: {
        startNewChat: false
    }
};

export default function (state = initialState, action) {
    switch (action.type) {
        case INTERNAL_CHAT_CONTACTS: {
            console.log(action)
            return { 
                ...state, 
                contacts: action.contacts, 
                userStatus: action?.userStatus ? action.userStatus : state.userStatus 
            }
        }
        /** Os grupos são juntados aqui, e não com a lista inteira montada na saga: o mesmo
         *  grupo pode chegar por mais de um caminho (listagem, resposta da criação, socket),
         *  e a junção sobre o estado atual evita que um sobrescreva o outro.
         */
        case INTERNAL_CHAT_GROUPS: {
            return { ...state, groups: mergeListedGroups(state.groups, action.data) }
        }
        case UPSERT_INTERNAL_CHAT_GROUP: {
            return { ...state, groups: upsertGroup(state.groups, action.data) }
        }
        case APPLY_INTERNAL_CHAT_GROUP_UPDATE: {
            return { ...state, groups: applyGroupUpdate(state.groups, action.data.group, action.data.loggedUserId) }
        }
        case PATCH_INTERNAL_CHAT_GROUP: {
            return { ...state, groups: patchGroup(state.groups, action.data.id, action.data.changes) }
        }
        case ADD_INTERNAL_CHAT_GROUP_MESSAGES: {
            return { ...state, groups: addGroupMessages(state.groups, action.data.id, action.data.messages, action.data.changes) }
        }
        case RECEIVE_INTERNAL_CHAT_GROUP_MESSAGE: {
            return { ...state, groups: receiveGroupMessage(state.groups, action.data, state.activeChat?.group) }
        }
        case REMOVE_INTERNAL_CHAT_GROUP: {
            return { ...state, groups: removeGroup(state.groups, action.data) }
        }
        case UPDATE_INTERNAL_CHAT_CONTACT_STATUS: {
            return { 
                ...state, 
                userStatus: { 
                    ...state.userStatus, 
                    byUserId: {
                        ...state.userStatus.byUserId,
                        [action.data.userId]: action.data
                    }
                } 
            }
        }
        case ACTIVE_INTERNAL_CHAT: {
            return { ...state, activeChat: action.data }
        }
        case UPDATE_INTERNAL_CHAT_MESSAGING_INFO: {
            if(state.activeChat?.user?.id){
                return { 
                    ...state, 
                    messaging: {
                        ...state.messaging,
                        [state.activeChat?.user?.id]: {
                            ...state.messaging[state.activeChat?.user?.id],
                            messageText: action.data
                        }
                    } 
                };
            } else {
                return state;
            }
        }
        case IS_LOADING: {
            return { ...state, isLoading: { ...state.isLoading, ...action.data } }
        }
        case SAGA_ERROR: {
            return { ...state, error: action.response};
        }
        default:
            return state
    }
}